import { render, staticRenderFns } from "./ClassManagement.vue?vue&type=template&id=96016d02&"
import script from "./ClassManagement.vue?vue&type=script&lang=js&"
export * from "./ClassManagement.vue?vue&type=script&lang=js&"
import style0 from "./ClassManagement.vue?vue&type=style&index=0&id=96016d02&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports